(() => {
  if (window.__orlavenDesignLabOrbitLoaded) return;
  window.__orlavenDesignLabOrbitLoaded = true;

  const views = ['front', 'right_sleeve', 'back', 'left_sleeve'];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = (root) => {
    if (root.dataset.ocbcOrbitReady === 'true') return;
    const stage = root.querySelector('[data-ocbc-preview]');
    if (!stage) return;

    root.dataset.ocbcOrbitReady = 'true';
    const autoButton = root.querySelector('[data-ocbc-auto-rotate]');
    const cleanup = [];
    let autoEnabled = false;
    let autoTimer = 0;
    let orbitTimer = 0;
    let pointerId = null;
    let pointerStartX = 0;
    let pointerStartY = 0;
    let suppressClick = false;
    let pausedByInteraction = false;

    const on = (target, type, handler, options) => {
      target?.addEventListener(type, handler, options);
      cleanup.push(() => target?.removeEventListener(type, handler, options));
    };

    const currentIndex = () => {
      const index = views.indexOf(root.dataset.activeView || 'front');
      return index < 0 ? 0 : index;
    };

    const showView = (direction) => {
      const nextIndex = (currentIndex() + direction + views.length) % views.length;
      const nextView = views[nextIndex];
      const button = root.querySelector(`[data-ocbc-view="${nextView}"]`);
      if (!button) return;

      root.dataset.orbitDirection = direction < 0 ? 'left' : 'right';
      root.style.setProperty('--orbit-direction', direction < 0 ? '-1' : '1');
      root.classList.add('is-orbiting');
      window.clearTimeout(orbitTimer);
      button.click();
      orbitTimer = window.setTimeout(() => root.classList.remove('is-orbiting'), reducedMotion.matches ? 0 : 280);
    };

    const stopTimer = () => {
      window.clearInterval(autoTimer);
      autoTimer = 0;
    };

    const startTimer = () => {
      stopTimer();
      if (!autoEnabled || pausedByInteraction || document.hidden || reducedMotion.matches) return;
      autoTimer = window.setInterval(() => showView(1), 2200);
    };

    const syncAutoButton = () => {
      if (!autoButton) return;
      autoButton.setAttribute('aria-pressed', autoEnabled ? 'true' : 'false');
      autoButton.title = autoEnabled ? 'Stop auto rotate' : 'Auto rotate';
    };

    root.querySelectorAll('[data-ocbc-orbit]').forEach((button) => {
      on(button, 'click', () => showView(button.dataset.ocbcOrbit === 'prev' ? -1 : 1));
    });

    on(autoButton, 'click', () => {
      autoEnabled = !autoEnabled;
      syncAutoButton();
      startTimer();
    });

    on(stage, 'keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showView(event.key === 'ArrowLeft' ? -1 : 1);
    });

    on(stage, 'pointerdown', (event) => {
      if (!event.isPrimary || event.button !== 0) return;
      pointerId = event.pointerId;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
      suppressClick = false;
      root.classList.add('is-dragging');
      stage.setPointerCapture?.(pointerId);
    });

    on(stage, 'pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const horizontal = event.clientX - pointerStartX;
      const vertical = event.clientY - pointerStartY;
      if (Math.abs(horizontal) > 12 && Math.abs(horizontal) > Math.abs(vertical)) {
        suppressClick = true;
        root.style.setProperty('--ocbc-drag-yaw', `${Math.max(-12, Math.min(12, horizontal / 8))}deg`);
      }
    });

    const finishPointer = (event) => {
      if (event.pointerId !== pointerId) return;
      const horizontal = event.clientX - pointerStartX;
      stage.releasePointerCapture?.(pointerId);
      pointerId = null;
      root.classList.remove('is-dragging');
      root.style.removeProperty('--ocbc-drag-yaw');
      if (Math.abs(horizontal) >= 42) showView(horizontal < 0 ? 1 : -1);
    };

    on(stage, 'pointerup', finishPointer);
    on(stage, 'pointercancel', finishPointer);
    on(stage, 'click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);

    const pause = () => {
      pausedByInteraction = true;
      stopTimer();
    };
    const resume = () => {
      pausedByInteraction = false;
      startTimer();
    };

    on(stage, 'pointerenter', pause);
    on(stage, 'pointerleave', resume);
    on(stage, 'focusin', pause);
    on(stage, 'focusout', resume);
    on(document, 'visibilitychange', startTimer);
    syncAutoButton();

    root.__orlavenOrbitCleanup = () => {
      cleanup.forEach((dispose) => dispose());
      stopTimer();
      window.clearTimeout(orbitTimer);
      delete root.__orlavenOrbitCleanup;
      delete root.dataset.ocbcOrbitReady;
    };
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-orlaven-custom-bomber]').forEach(init);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-orlaven-custom-bomber]').forEach((root) => root.__orlavenOrbitCleanup?.());
  });
})();
